module.exports = __webpack_public_path__ + "img/4-6-2022_arakpacha_thumb.b7fa00a2.jpeg";